var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { dataTableConfigFields } from '../DataTableFormioIntegration';
export default __spreadArrays([
    {
        key: 'placeholder',
        ignore: true
    },
    {
        label: 'Sortable',
        type: 'checkbox',
        input: true,
        key: 'sortable',
        weight: 442,
        defaultValue: true
    },
    {
        label: 'Filterable',
        type: 'checkbox',
        input: true,
        key: 'filterable',
        weight: 442,
        defaultValue: true
    },
    {
        label: 'Inline editing',
        type: 'checkbox',
        input: true,
        key: 'inlineEditing',
        weight: 442,
        defaultValue: false,
        customConditional: function (ctx) {
            var _a;
            return !((_a = ctx.data.fetch) === null || _a === void 0 ? void 0 : _a.enableFetch);
        }
    },
    {
        type: 'textfield',
        label: 'Cell max width',
        input: true,
        key: 'cellMaxWidth',
        defaultValue: '',
        weight: 442,
    },
    {
        label: 'Clip cells',
        type: 'checkbox',
        input: true,
        key: 'clipCells',
        weight: 442,
        defaultValue: false
    },
    {
        type: 'select',
        input: true,
        key: 'itemsPerPage',
        label: 'Items per page',
        weight: 442,
        defaultValue: 10,
        dataSrc: 'values',
        data: {
            values: [
                { label: '5', value: 5 },
                { label: '10', value: 10 },
                { label: '25', value: 25 },
                { label: '50', value: 50 },
                { label: '100', value: 100 },
                { label: 'All', value: -1 },
            ],
        },
    },
    {
        label: 'Show add button',
        type: 'checkbox',
        input: true,
        key: 'showAddBtn',
        weight: 442,
        defaultValue: true,
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return !_.get(data, 'fetch.enableFetch');
        },
    },
    {
        label: 'Show edit button',
        type: 'checkbox',
        input: true,
        key: 'showEditBtn',
        weight: 442,
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return !_.get(data, 'fetch.enableFetch');
        },
        defaultValue: true
    },
    {
        label: 'Show delete button',
        type: 'checkbox',
        input: true,
        key: 'showDeleteBtn',
        weight: 442,
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return !_.get(data, 'fetch.enableFetch');
        },
        defaultValue: true
    },
    {
        label: 'Show delete all button',
        type: 'checkbox',
        input: true,
        key: 'showDeleteAllBtn',
        customConditional: function (_a) {
            var data = _a.data, _ = _a._;
            return !_.get(data, 'fetch.enableFetch');
        },
        weight: 442,
        defaultValue: false
    },
    {
        type: 'textfield',
        label: 'Delete all confirmation message',
        input: true,
        key: 'deleteAllConfirmationMessage',
        defaultValue: 'Are you sure you wish to delete all rows?',
        weight: 442,
        conditional: {
            json: {
                '===': [{ var: 'data.showDeleteAllBtn' }, true],
            },
        },
    }
], dataTableConfigFields());
